/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Username_Check_RetryInputs */

const en_onboarding_v1_username_check_retry = /** @type {(inputs: Onboarding_V1_Username_Check_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't check that name. Try again.`)
};

const de_onboarding_v1_username_check_retry = /** @type {(inputs: Onboarding_V1_Username_Check_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Name konnte nicht geprüft werden. Versuchen Sie es erneut.`)
};

const pt_br2_onboarding_v1_username_check_retry = /** @type {(inputs: Onboarding_V1_Username_Check_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível verificar esse nome. Tente novamente.`)
};

const tr_onboarding_v1_username_check_retry = /** @type {(inputs: Onboarding_V1_Username_Check_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu ad kontrol edilemedi. Tekrar deneyin.`)
};

const zh_cn2_onboarding_v1_username_check_retry = /** @type {(inputs: Onboarding_V1_Username_Check_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法检查该名称。请重试。`)
};

const zh_hk2_onboarding_v1_username_check_retry = /** @type {(inputs: Onboarding_V1_Username_Check_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法檢查此名稱。請重試。`)
};

const ko_kr2_onboarding_v1_username_check_retry = /** @type {(inputs: Onboarding_V1_Username_Check_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`해당 이름을 확인할 수 없습니다. 다시 시도하세요.`)
};

const ru_ru2_onboarding_v1_username_check_retry = /** @type {(inputs: Onboarding_V1_Username_Check_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось проверить это имя. Попробуйте ещё раз.`)
};

const es_419_onboarding_v1_username_check_retry = /** @type {(inputs: Onboarding_V1_Username_Check_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos comprobar ese nombre. Inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Couldn't check that name. Try again." |
*
* @param {Onboarding_V1_Username_Check_RetryInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_username_check_retry = /** @type {((inputs?: Onboarding_V1_Username_Check_RetryInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Username_Check_RetryInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_username_check_retry(inputs)
	if (locale === "de") return de_onboarding_v1_username_check_retry(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_username_check_retry(inputs)
	if (locale === "tr") return tr_onboarding_v1_username_check_retry(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_username_check_retry(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_username_check_retry(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_username_check_retry(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_username_check_retry(inputs)
	return es_419_onboarding_v1_username_check_retry(inputs)
});